const formatTime = (time: string) => time.replace(".", ",");

const convertVTTtoSRT = (vttText: string): string => {
  const subtitleBlocks = vttText.trim().split(/\n\s*\n/);

  // Iterate through each subtitle block and convert it to SRT format
  let subtitleCount = 1;
  const srtText = subtitleBlocks.map(subtitleBlock => {
    const lines = subtitleBlock.split("\n");
    if (lines.length >= 3) {
      const times = lines[1].split(" --> ");
      if (times.length === 2) {
        const startTime = formatTime(times[0]);
        const endTime = formatTime(times[1]);
        const text = lines.slice(2).join("\n");
        const srtSubtitle = `${subtitleCount}\n${startTime} --> ${endTime}\n${text}\n`;
        subtitleCount += 1;
        return srtSubtitle;
      }
    }
    return null; // Skip malformed subtitle blocks
  }).filter(subtitle => subtitle !== null).join("\n");

  return srtText;
};

export default convertVTTtoSRT;
